import { render } from "./PDFPreviewDialog.vue?vue&type=template&id=1cce478f&scoped=true"
import script from "./PDFPreviewDialog.vue?vue&type=script&lang=js"
export * from "./PDFPreviewDialog.vue?vue&type=script&lang=js"

import "./PDFPreviewDialog.vue?vue&type=style&index=0&id=1cce478f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cce478f"]])

export default __exports__